import type { DateFormatPreference, MeasurementSystem, SupportedLanguage } from "../types/domain";

const locales: Record<SupportedLanguage, string> = {
  it: "it-IT",
  en: "en-US",
  es: "es-ES"
};

export function formatMoney(value: number, currency: string, language: SupportedLanguage): string {
  return new Intl.NumberFormat(locales[language], {
    style: "currency",
    currency
  }).format(value);
}

export function formatNumber(value: number, language: SupportedLanguage): string {
  return new Intl.NumberFormat(locales[language]).format(value);
}

export function formatDate(value: Date | string, format: DateFormatPreference): string {
  const date = value instanceof Date ? value : new Date(value);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  if (format === "MM/DD/YYYY") return `${mm}/${dd}/${yyyy}`;
  if (format === "YYYY-MM-DD") return `${yyyy}-${mm}-${dd}`;
  return `${dd}/${mm}/${yyyy}`;
}

export function distanceUnit(system: MeasurementSystem): "km" | "mi" {
  return system === "imperial" ? "mi" : "km";
}

export function temperatureUnit(system: MeasurementSystem): "°F" | "°C" {
  return system === "imperial" ? "°F" : "°C";
}


export function formatDateTime(value: Date | string, format: DateFormatPreference, language: SupportedLanguage): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return `${formatDate(date, format)} ${new Intl.DateTimeFormat(locales[language], { hour: "2-digit", minute: "2-digit" }).format(date)}`;
}
